import { useEffect } from "react";
import { useParams } from "react-router-dom";

const AppRedirect = () => {
  const { gym_id } = useParams();

  useEffect(() => {
    if (gym_id) {
      const deepLink = `yupluck://appgym/${gym_id}`; // path-based deep link
      const fallbackURL = {
        ios: "https://apps.apple.com/in/app/yupluck/id6737851845",
        android: "https://play.google.com/store/apps/details?id=com.yupluck.mepluck"
      };

      const userAgent = navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      const isAndroid = /android/.test(userAgent);

      // Attempt to open the app
      window.location.href = deepLink;

      // Fallback after 2 seconds
      setTimeout(() => {
        if (isIOS) {
          window.location.href = fallbackURL.ios;
        } else if (isAndroid) {
          window.location.href = fallbackURL.android;
        } else {
          // Optional: fallback for web or unsupported platforms
          window.location.href = "https://yupluck.com";
        }
      }, 2000);
    }
  }, [gym_id]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Opening Yupluck App…</h2>
      <p>If you are not redirected, <a href={`yupluck://appgym/${gym_id}`}>click here to open in the app</a>.</p>
    </div>
  );
};

export default AppRedirect;
